// Hooks
import { useTranslation } from 'react-i18next';

// Interfaces
import { MiddlewareTranslation } from '../interfaces/Profile';
import { useCallback } from 'react';

const useTranslate = () => {

    const { i18n } = useTranslation();

    const translateMiddleware = useCallback((mwTranslation: MiddlewareTranslation | undefined) => {
        if (!mwTranslation) return null;
        return mwTranslation.translations.find(trans => trans.language_id === i18n.language);
    }, [i18n.language]);

    return { translateMiddleware };
};

export default useTranslate;